(() => {
  const addNoFollowToExternalLinks = () => {
    const siteHost = window.location.hostname;

    document.querySelectorAll('a[href]').forEach((a) => {
      const href = a.getAttribute('href');
      if (!href) return;

      // Skip non-web links and in-page anchors
      if (
        href.startsWith('#') ||
        href.startsWith('mailto:') ||
        href.startsWith('tel:') ||
        href.startsWith('javascript:')
      ) {
        return;
      }

      let url;
      try {
        // Handles relative and absolute URLs
        url = new URL(href, window.location.href);
      } catch {
        return;
      }

      // Only treat http/https as "external links"
      if (url.protocol !== 'http:' && url.protocol !== 'https:') return;

      const linkHost = url.hostname;
      if (!linkHost) return;

      // Treat same host + subdomains as internal
      const isInternal =
        linkHost === siteHost ||
        linkHost.endsWith(`.${siteHost}`) ||
        siteHost.endsWith(`.${linkHost}`);

      if (isInternal) return;

      // Add 'nofollow' while preserving existing rel tokens
      const rel = (a.getAttribute('rel') || '')
        .split(/\s+/)
        .filter(Boolean);

      if (!rel.includes('nofollow')) rel.push('nofollow');
      a.setAttribute('rel', rel.join(' '));
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', addNoFollowToExternalLinks, { once: true });
  } else {
    addNoFollowToExternalLinks();
  }
})();
